import React, { useEffect, useState, useMemo } from "react";
import { useParams }   from "react-router-dom";
import axios           from "axios";
import DOMPurify       from "dompurify";           //  npm i dompurify
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";

const VersionView = () => {
  const { id } = useParams();

  /* i18n -------------------------------------------------- */
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = useMemo(() => (k, d = "") => translations[k] || d, [translations]);

  /* state ------------------------------------------------- */
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/versions/${id}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
        );
        setData(data);
      } catch (e) {
        console.error("Versiyon getirilemedi:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) return <p className="text-center py-5">{t("LOADING", "Yükleniyor…")}</p>;
  if (!data)    return <p className="text-center py-5">{t("NOT_FOUND", "Kayıt yok")}</p>;

  return (
    <div className="container mt-4">
      <div className="card card-body">
        <h2 className="fw-bold mb-3">{data.title}</h2>

        <div
          className="version-content"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.content) }}
        />
      </div>
    </div>
  );
};

export default VersionView;
